import { useQuery } from 'react-query';
import request from '../../../../../../helpers/request';
import { getQueryKeys } from '../../../../queries/queryKeys';

const key = ({ serviceCompanyId, registrationTypeId }) => [
  'templates',
  serviceCompanyId,
  registrationTypeId,
];

const fetchTemplates = async (params) => {
  const res = await request.get(
    `/HousingStock/house_access_types`,
    params,
    'Не удалось загрузить шаблоны'
  );

  return res;
};

const useHouseTemplates = (params = {}, options) =>
  useQuery(getQueryKeys.templates(params), () => fetchTemplates(params), options);

export { key as houseTemplatesKey, useHouseTemplates };